// Protection temporaire du site par mot de passe (écran client, pas une sécurité serveur).
// Pour changer le mot de passe : générer un nouveau hash SHA-256 et remplacer SITE_PASSWORD_HASH.
// Pour retirer la protection : ne plus passer par <Root>, rendre <App> directement
// (voir public/js/app.js et server/entryServer.mjs).
import React from 'react';

const SITE_PASSWORD_HASH = '00e90db7e4149c355dba902440266465af5e4ceee2031cbee0a03bc1d5a9b761';
const SITE_UNLOCK_KEY = 'site-unlocked';

async function hashPassword(value) {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export function isSiteUnlocked() {
  // Le rendu serveur n'a pas de sessionStorage : il affiche donc toujours cet écran
  // (comportement voulu tant que la protection reste active).
  if (typeof window === 'undefined') {
    return false;
  }
  return window.sessionStorage.getItem(SITE_UNLOCK_KEY) === 'true';
}

export function PasswordGate({ onUnlock }) {
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [checking, setChecking] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setChecking(true);
    setError('');
    const hash = await hashPassword(password);
    if (hash === SITE_PASSWORD_HASH) {
      window.sessionStorage.setItem(SITE_UNLOCK_KEY, 'true');
      onUnlock();
    } else {
      setError('Mot de passe incorrect.');
      setChecking(false);
    }
  };

  return (
    <div className="password-gate">
      <form className="password-gate-box" onSubmit={handleSubmit}>
        <h1>Accès protégé</h1>
        <p>Ce site est temporairement protégé par un mot de passe.</p>
        <input
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          placeholder="Mot de passe"
          autoFocus
        />
        {error && <p className="password-gate-error">{error}</p>}
        <button type="submit" disabled={checking || !password}>
          {checking ? 'Vérification…' : 'Accéder au site'}
        </button>
      </form>
    </div>
  );
}
